// extracted by mini-css-extract-plugin
module.exports = {"partnershipBeginContainer":"PartnershipType_partnershipBeginContainer__1QfpS"};